var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.22 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BT_Closed-Nav_logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.07,9.54A4.14,4.14,0,0,0,27.71,6c-3.44-1.73-7.33-.44-8.63.09,0,0,.15.51,0-2.17A4.11,4.11,0,0,0,16.28.39,10.08,10.08,0,0,0,9.16,1c-.24.1-7.08,4.35-8.25,5.08A1.45,1.45,0,0,0,.14,7.23V13c0,.64.32.78.38.82C1.83,14.61,15.31,22.38,19,24.4c.55.32.68.4.93.39s.45-.16,1-.45c1.64-.93,1.9-1,4.69-2.74s4.51-3.17,4.51-4.46C30.06,15.36,30.09,10.09,30.07,9.54ZM9,7.8a8.37,8.37,0,0,1,7.3-.45L9,11.62,5.8,9.78Zm16.35,6.67-5.73,3.28L15,15.09l3.41-2s4.69-3,9.58-.49A12.48,12.48,0,0,1,25.34,14.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.24,16.68l-.67-.36a.38.38,0,0,0-.52.13.35.35,0,0,0,0,.13V22.5a1.11,1.11,0,0,0,.5.86s13.17,7.47,13.17,7.57-3.17,1.84-3.17,1.84a1.1,1.1,0,0,0-.49.86v6c0,.32.22.45.49.29l8.9-5.15a5.12,5.12,0,0,1,.52-.27h0a5.14,5.14,0,0,1,.49-.32l9.31-5.39a1.08,1.08,0,0,0,.5-.86V22c0-.31-.22-.44-.5-.28l-9.39,5.38a1.1,1.1,0,0,1-1,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logoSmall.aca76fe163d150e54e2058500a048eae.svg";
export { ForwardRef as ReactComponent };